import type { Holiday } from '@/views/TicketCheckoutViews/ShowtimesView/components/HolidayDates/holidayConstants'

export const getGradient = (holiday: Holiday, isSelected: boolean, isHovered: boolean) => {
  if (isSelected) {
    return 'none'
  }

  return isHovered
    ? `linear-gradient(to top, ${holiday.color}33, transparent)`
    : `linear-gradient(to top, ${holiday.color}14, transparent)`
}

export const getBoxShadow = (holiday: Holiday, isSelected: boolean) => {
  if (isSelected) {
    return '0 8px 16px -1px rgba(0,0,0,0.08)'
  }

  return `inset 0 0 0 1px #E6E6E6, 0 0 0 0.5px ${holiday.color}4D`
}

export const getDateStyle = (holiday: Holiday, isSelected: boolean) => {
  if (isSelected) {
    return {
      color: 'transparent',
      background: 'linear-gradient(to bottom, rgba(255,255,255,0.3), rgba(255,255,255,0.3), rgba(255,255,255,0.3))',
    }
  }

  return {
    color: 'transparent',
    background: `linear-gradient(to bottom, ${holiday.color}2A, ${holiday.color}2A`,
  }
}

export const getHolidayNameStyle = (holiday: Holiday, isSelected: boolean) => {
  if (isSelected) {
    return { color: 'white' }
  }

  return {
    background: `linear-gradient(to bottom, ${holiday.color}, ${holiday.color})`,
    WebkitTextFillColor: 'transparent',
    color: 'transparent',
  }
}

export const getDateTextColor = (holiday: Holiday, isSelected: boolean) => {
  if (isSelected) {
    return { color: 'white' }
  }

  return { color: `${holiday.color}` }
}

export const getBorderColor = (holiday: Holiday, isSelected: boolean) => {
  if (isSelected) {
    return { borderColor: 'transparent' }
  }

  return { borderColor: holiday.color }
}
